import { render, staticRenderFns } from "./AdvisorAlert.vue?vue&type=template&id=7821dddc&scoped=true"
import script from "./AdvisorAlert.vue?vue&type=script&lang=ts"
export * from "./AdvisorAlert.vue?vue&type=script&lang=ts"
import style0 from "./AdvisorAlert.vue?vue&type=style&index=0&id=7821dddc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7821dddc",
  null
  
)

export default component.exports